<template>
	<div class="payCode">
		<van-nav-bar title="支付密码" left-arrow @click-left="backClick" />
		<div style="height: 10px; background-color: #eeeeee"></div>

		<div v-if="!userInfo.payPassword">
			<div style="padding: 10px">请设置支付密码</div>
			<van-tabs v-model="active">
				<van-tab title="设置支付密码">
					<!-- 输入框 -->
					<div style="margin-top: 30px; padding: 10px">
						<van-field
							v-model.trim="form.mobile"
							type="tel"
							label="手机号:"
							disabled
						/>
						<van-field
							v-model.trim="form.newPassword"
							type="tel"
							label="密码:"
							placeholder=""
							maxlength="6"
						>
							<template #button>
								<span>6位数的纯数字</span>
							</template>
						</van-field>
						<div style="margin-top: 16px">
							<van-button color="#c03131" block type="danger" @click="newSubmit"
								>提交</van-button
							>
						</div>
					</div>
					<div
						style="margin-top: 80px; margin-left: 10px; height: 100px"
						@click="newSubmit"
					>
						无法提交?点此重试提交
					</div>
				</van-tab>
			</van-tabs>
		</div>
		<div v-else-if="userInfo.payPassword && isEdit">
			<div style="padding: 10px">请选择以下一种方式修改支付密码</div>
			<van-tabs v-model="active">
				<van-tab title="手机号验证">
					<!-- 输入框 -->
					<div style="margin-top: 30px; padding: 10px">
						<van-form @submit="submit">
							<van-field
								v-model.trim="form.mobile"
								name="手机号"
								type="tel"
								label="手机号:"
								disabled
								placeholder=""
							/>
							<van-field
								v-model="form.code"
								center
								maxlength="6"
								label="验证码:"
								placeholder=""
							>
								<template #button>
									<span v-if="!codeTimes" @click="getCode">发送验证码</span>
									<span v-else>{{ codeTimes }}秒 </span>
								</template>
							</van-field>
							<van-field
								v-model.trim="form.newPassword"
								name="新密码"
								type="tel"
								label="新密码:"
								placeholder=""
								maxlength="6"
							>
								<template #button>
									<span>6位数的纯数字</span>
								</template>
							</van-field>
							<div style="margin-top: 16px">
								<van-button
									color="#c03131"
									block
									type="danger"
									native-type="submit"
									>提交</van-button
								>
							</div>
						</van-form>
					</div>
				</van-tab>
				<van-tab title="旧密码验证">
					<!-- 输入框 -->
					<div style="margin-top: 30px; padding: 10px">
						<van-form @submit="submit2">
							<van-field
								v-model.trim="form.oldPassword"
								name="旧密码"
								type="tel"
								label="旧密码:"
								placeholder=""
								maxlength="6"
							/>
							<van-field
								v-model.trim="form.newPassword"
								name="新密码"
								type="tel"
								label="新密码:"
								placeholder=""
								maxlength="6"
							>
								<template #button>
									<span>6位数的纯数字</span>
								</template>
							</van-field>
							<div style="margin-top: 16px">
								<van-button
									color="#c03131"
									block
									type="danger"
									native-type="submit2"
									>提交</van-button
								>
							</div>
						</van-form>
					</div></van-tab
				>
				<van-tab title="其他方式">
					<div style="margin-top: 30px; padding: 10px; background-color: #fff">
						<div style="margin-bottom: 20px">
							暂无其他修改方式,如需帮助请联系客服
						</div>
						<div @click="tophone">
							客服电话:
							<span style="color: #1989fa; margin-left: 20px">{{
								mallInfo.serviceTelephone
							}}</span>
							<span style="color: #c8c9c9; margin-left: 10px">点击呼叫</span>
						</div>
					</div>
				</van-tab>
			</van-tabs>
		</div>
		<div v-if="userInfo.payPassword && !isEdit" style="margin-top: 30px">
			<!-- <van-field
        label="输入密码"
        type="password"
        :value="passwordValue"
        @touchstart.native.stop="show = true"
      /> -->
			<van-password-input :value="passwordValue" />
			<div style="margin: 10px; color: red; height: 20px">
				<span v-if="isPassWordError"> 密码输入错误!</span>
			</div>
			<div
				style="margin: 20px; text-align: right; color: #666666b3"
				@click="isEdit = true"
			>
				忘记密码?
			</div>
			<van-number-keyboard
				v-model="passwordValue"
				:show="show"
				theme="custom"
				@close="boardClose"
				close-button-text="完成"
				:maxlength="6"
			/>
		</div>
	</div>
</template>

<script>
import { memberPay, codeNtoken, loginMobileCheck } from "@/utils/api.js";
export default {
	data() {
		return {
			show: true,
			isPassWordError: false,
			passwordValue: "",
			isEdit: false,
			active: 0,
			form: {},
			mallInfo: {},
			codeTimes: "",
			tenantId: "",
			userInfo: {},
		};
	},
	async created() {
		this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
		this.mallInfo = JSON.parse(localStorage.getItem("mallInfo"));
		this.$set(this.form, "mobile", this.userInfo.mobile);
	},
	watch: {
		passwordValue(value) {
			let val = value.split("");
			if (val.length === 6) {
				if (value == this.userInfo.payPassword) {
					this.$emit("passwordBackClick", true);
				} else {
					this.isPassWordError = true;
				}
			} else {
				this.isPassWordError = false;
			}
		},
	},
	methods: {
		boardClose() {
			this.$toast.fail("请输入正确的六位数密码!");
		},
		backClick() {
			if (!this.isEdit) {
				this.$emit("passwordBackClick", false);
			} else {
				this.isEdit = false;
			}
		},
		tophone() {
			window.location.href = `tel:${this.mallInfo.serviceTelephone}`;
		},
		async getCode() {
			const reg = /^1\d{10}$/;
			if (!reg.test(this.form.mobile)) {
				return this.$toast("请输入正确的手机号");
			}
			const res = await codeNtoken({
				mobile: this.form.mobile,
				tenantId: 963422,
				mallId: 1,
			});
			this.$toast("发送成功!");
			this.codeTimes = 60;

			this.codeTimesChange();
		},
		mobileChange() {
			this.codeTimes = null;
		},
		codeTimesChange() {
			if (this.codeTimes) {
				if (this.codeTimes === 1) {
					this.codeTimes = "";
				}
				setTimeout(() => {
					if (this.codeTimes) {
						this.codeTimes--;
						this.codeTimesChange();
					}
				}, 1000);
			}
		},
		async newSubmit() {
			try {
				if (!this.form.newPassword) {
					return this.$toast.fail("请输入您要设置的密码");
				}
				if (isNaN(+this.form.newPassword)) {
					return this.$toast.fail("请输入纯数字的密码");
				}
				if (this.form.newPassword.length != 6) {
					return this.$toast.fail("请输入6位数的密码");
				}
				let params = { value: this.form.newPassword };
				await memberPay(params);

				this.$toast.success("会员信息修改成功！");
				this.$set(this.userInfo, "payPassword", this.form.newPassword);
				localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
				this.isEdit = false;
			} catch (error) {
				alert(`用户信息异常,请联系客服${error}`);
			}
		},
		async submit() {
			if (!this.form.mobile || !this.form.code || !this.form.newPassword) {
				return;
			}
			if (isNaN(+this.form.newPassword)) {
				return this.$toast.fail("请输入纯数字的密码");
			}
			if (this.form.newPassword.length != 6) {
				return this.$toast.fail("请输入6位数的密码");
			}
			let params = JSON.parse(JSON.stringify(this.form));
			await loginMobileCheck({
				...params,
				tenantId: 963422,
				mallId: 1,
				storeId: 1,
			});
			const res = await memberPay({
				value: this.form.newPassword,
			});

			this.$set(this.userInfo, "payPassword", this.form.newPassword);

			localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
			this.$toast.success(res.message);
			this.isEdit = false;
		},
		async submit2() {
			if (!this.form.oldPassword || !this.form.newPassword) {
				return;
			}
			if (isNaN(+this.form.newPassword)) {
				return this.$toast.fail("请输入纯数字的密码");
			}
			if (this.form.newPassword.length != 6) {
				return this.$toast.fail("请输入6位数的密码");
			}
			if (this.form.oldPassword != this.userInfo.payPassword) {
				return this.$toast.fail("旧密码输入错误!");
			}
			const res = await memberPay({
				value: this.form.newPassword,
			});

			this.$set(this.userInfo, "payPassword", this.form.newPassword);
			localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
			this.$toast.success(res.message);
			this.isEdit = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.payCode {
	font-size: 14px !important;
	background-color: #eee;
	height: 100%;
}
</style>